import { render, staticRenderFns } from "./CashbackAndPoints.vue?vue&type=template&id=2450e7dc&scoped=true"
import script from "./CashbackAndPoints.vue?vue&type=script&lang=js"
export * from "./CashbackAndPoints.vue?vue&type=script&lang=js"
import style0 from "./CashbackAndPoints.vue?vue&type=style&index=0&id=2450e7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450e7dc",
  null
  
)

export default component.exports